import { whiteColor } from "@config"
import React from "react"
import * as styles from "./pageMostAlbums.module.scss"

import createPage from "@src/components/page"
import classnames from "@src/utils/classnames"
import { animated } from "@react-spring/web"
import { callYou, useEnteringTrail } from "@src/components/page/lib"
import { imageCdnUrl } from "@src/utils/request"
import bgImg from "@images/2022/p6/26-100.jpg"

const PageMostAlbums = createPage(
  ({ data, offset }) => {
    const { albums } = data
    // const albums = [a[0], a[0], a[0]]
    const anime1Styles = useEnteringTrail(albums.length, offset, { type: "mt" })
    const anime2Styles = useEnteringTrail(2, offset, { step: 0.7 })
    const anime3Styles = useEnteringTrail(1, offset, { step: 0.9 })
    return (
      <>
        <div>
          <div className={styles.framesContainer}>
            <div className={styles.frames}>
              {albums.map((album, i) => (
                <animated.div
                  key={album.id}
                  style={anime1Styles[i]}
                  className={classnames(styles.frame, styles[`frame${i + 1}`])}
                >
                  <img
                    src={imageCdnUrl(album.attributes.cover, {
                      w: 460,
                      h: 460,
                    })}
                    alt="播单封面"
                  />
                </animated.div>
              ))}
            </div>
          </div>
        </div>
        <div>
          <animated.p style={anime2Styles[0]}>
            今年{callYou(data)}最喜欢听的
            <br />
            播单{albums.length === 1 ? "" : `前${albums.length}名分别`}是
          </animated.p>
          <animated.p style={anime2Styles[1]}>
            {albums.map((album) => (
              <div key={album.id}>
                <b>{album.attributes.title}</b>
              </div>
            ))}
          </animated.p>
        </div>
        <animated.div className="bottomText" style={anime3Styles[0]}>
          2022 年机核被收听最多的播单
          <br />
          《一档七嘴八舌的群口读书分享节目》
        </animated.div>
      </>
    )
  },
  {
    className: "pageLayout1",
  }
)

export const pageMostAlbumsData = {
  key: "mostAlbums",
  bgImg,
  Page: PageMostAlbums,
  shouldHide: ({ albums }) => {
    return albums.length === 0
  },
}

export default PageMostAlbums
